import { createSlice } from '@reduxjs/toolkit'

const dialogSlice = createSlice({
  name: 'dialogSlice',
  initialState: {
    deleteDialog: false,
    approveDialog: false,
    listDialog: false,
    rejectDialog: false,
    holdDialog: false,
    logDialog: false,
    saveDialog: false,
    saveDialogSuccess: false,
    matchDialog: false,
    saveAndCloseDialog: false,
    saveAndNewDialog: false,
    createDialog: false,
    attachment: false,
    attachmentMain: false,
    attachmentInner: false,
    uploadAttachmentDialog: false,
    dataGridDialog: false,
    submitDialog: false,
    sendToApproveDialog: false,
    checkVendorsDialog: false,
    createRequest: false,
    taxDialog: false,
    selectDialog: false,
    showDialog: false,
    printDialog: false,
    confirmDialog: false,
    createPODialog: false,
    retrieveDialog: false,
    sendToBankDialog: false,
    payDialog: false,
    returnToApprovedDialog: false,
    changeBank: false,
    copyRequestDialog: false,
    postToS: false,
    transferToSunsystemsDialog: false,
    excelImportDialog: false,
    excelDownloadDialog: false,
    submitAndCreate: false
  },
  reducers: {
    showDeleteDialog: (state) => {
      state.deleteDialog = true
    },
    hideDeleteDialog: (state) => {
      state.deleteDialog = false
    },
    showApproveDialog: (state) => {
      state.approveDialog = true
    },
    hideApproveDialog: (state) => {
      state.approveDialog = false
    },
    showListDialog: (state) => {
      state.listDialog = true
    },
    hideListDialog: (state) => {
      state.listDialog = false
    },
    showRejectDialog: (state) => {
      state.rejectDialog = true
    },
    hideRejectDialog: (state) => {
      state.rejectDialog = false
    },
    showHoldDialog: (state) => {
      state.holdDialog = true
    },
    hideHoldDialog: (state) => {
      state.holdDialog = false
    },
    showLogDialog: (state) => {
      state.logDialog = true
    },
    hideLogDialog: (state) => {
      state.logDialog = false
    },
    toggleSaveDialogSuccess: (state) => {
      state.saveDialogSuccess = false
    },
    showSaveDialog: (state) => {
      state.saveDialog = true
    },
    hideSaveDialog: (state) => {
      state.saveDialog = false
    },
    showMatchDialog: (state) => {
      state.matchDialog = true
    },
    hideMatchDialog: (state) => {
      state.matchDialog = false
    },
    showSaveAndCloseDialog: (state) => {
      state.saveAndCloseDialog = true
    },
    hideSaveAndCloseDialog: (state) => {
      state.saveAndCloseDialog = false
    },
    showSaveAndNewDialog: (state) => {
      state.saveAndNewDialog = true
    },
    hideSaveAndNewDialog: (state) => {
      state.saveAndNewDialog = false
    },
    showCreateDialog: (state) => {
      state.createDialog = true
    },
    hideCreateDialog: (state) => {
      state.createDialog = false
    },
    showDataGridDialog: (state) => {
      state.dataGridDialog = true
    },
    hideDataGridDialog: (state) => {
      state.dataGridDialog = false
    },
    showSubmitDialog: (state) => {
      state.submitDialog = true
    },
    hideSubmitDialog: (state) => {
      state.submitDialog = false
    },
    showTaxDialog: (state) => {
      state.taxDialog = true
    },
    hideTaxDialog: (state) => {
      state.taxDialog = false
    },
    showSendToApproveDialog: (state) => {
      state.sendToApproveDialog = true
    },
    hideSendToApproveDialog: (state) => {
      state.sendToApproveDialog = false
    },
    toggleCheckVendors: (state) => {
      state.checkVendorsDialog = !state.checkVendorsDialog
    },
    toggleCreateRequest: (state) => {
      state.createRequest = !state.createRequest
    },
    toggleSelectDialog: (state) => {
      state.selectDialog = !state.selectDialog
    },
    toggleShowDialog: (state) => {
      state.showDialog = !state.showDialog
    },
    togglePrintDialog: (state) => {
      state.printDialog = !state.printDialog
    },
    toggleConfirmDialog: (state) => {
      state.confirmDialog = !state.confirmDialog
    },
    toggleUploadDialog: (state) => {
      state.attachment = !state.attachment
    },
    toggleUploadDialogMain: (state) => {
      state.attachmentMain = !state.attachmentMain
    },
    toggleUploadDialogInner: (state) => {
      state.attachmentInner = !state.attachmentInner
    },
    toggleUploadAttachmentDialog: (state) => {
      state.uploadAttachmentDialog = !state.uploadAttachmentDialog
    },
    toggleCreatePODialog: (state) => {
      state.createPODialog = !state.createPODialog
    },
    toggleRetrieveDialog: (state) => {
      state.retrieveDialog = !state.retrieveDialog
    },
    toggleSendtoBankDialog: (state) => {
      state.sendToBankDialog = !state.sendToBankDialog
    },
    togglePayDialog: (state) => {
      state.payDialog = !state.payDialog
    },
    toggleChangeBankDialog: (state) => {
      state.changeBank = !state.changeBank
    },
    toggleReturnToApprovedDialog: (state) => {
      state.returnToApprovedDialog = !state.returnToApprovedDialog
    },
    toggleCopyRequestDialog: (state) => {
      state.copyRequestDialog = !state.copyRequestDialog
    },
    togglePostToS: (state) => {
      state.postToS = !state.postToS
    },
    toggleTransferToSunsystemsDialog: (state) => {
      state.transferToSunsystemsDialog = !state.transferToSunsystemsDialog
    },
    toggleExcelImportDialog: (state) => {
      state.excelImportDialog = !state.excelImportDialog
    },
    toggleExcelDownloadDialog: (state) => {
      state.excelDownloadDialog = !state.excelDownloadDialog
    },
    toggleSubmitAndCreate: (state) => {
      state.submitAndCreate = !state.submitAndCreate
    },
  },
})

export const {
  showDeleteDialog,
  hideDeleteDialog,
  showListDialog,
  hideListDialog,
  showApproveDialog,
  hideApproveDialog,
  showRejectDialog,
  hideRejectDialog,
  showHoldDialog,
  hideHoldDialog,
  showLogDialog,
  hideLogDialog,
  toggleSaveDialogSuccess,
  showSaveDialog,
  hideSaveDialog,
  showMatchDialog,
  hideMatchDialog,
  showCreateDialog,
  hideCreateDialog,
  showDataGridDialog,
  hideDataGridDialog,
  showSubmitDialog,
  hideSubmitDialog,
  hideSaveAndCloseDialog,
  hideSaveAndNewDialog,
  showSaveAndCloseDialog,
  showSaveAndNewDialog,
  showSendToApproveDialog,
  hideSendToApproveDialog,
  toggleCheckVendors,
  toggleCreateRequest,
  hideTaxDialog,
  showTaxDialog,
  toggleSelectDialog,
  toggleShowDialog,
  togglePrintDialog,
  toggleConfirmDialog,
  toggleUploadDialog,
  toggleUploadDialogInner,
  toggleUploadDialogMain,
  toggleUploadAttachmentDialog,
  toggleCreatePODialog,
  toggleRetrieveDialog,
  toggleSendtoBankDialog,
  togglePayDialog,
  toggleChangeBankDialog,
  toggleReturnToApprovedDialog,
  toggleCopyRequestDialog,
  togglePostToS,
  toggleTransferToSunsystemsDialog,
  toggleExcelImportDialog,
  toggleExcelDownloadDialog,
  toggleSubmitAndCreate,
} = dialogSlice.actions

export const dialogReducer = dialogSlice.reducer